import {TranslationObject} from '@colonist/i18n'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {Sound} from '../../../shared/scripts/Sound'
import {createDivIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {uiManager} from '../EntryMobile'
import {UIMFullscreenHeader} from '../ui_html/header/UIMFullscreenHeader'

export abstract class UIMFullscreenPageView {
    page: HTMLDivElement
    container: HTMLDivElement
    body: HTMLDivElement
    header: UIMFullscreenHeader
    pageId: string

    private title: TranslationObject
    private readonly showHeader: boolean
    private readonly backButtonAction?: (() => void) | undefined
    private readonly bodyClass?: string | undefined

    private hasBeenBuilt = false

    protected shouldHideOnBackButton = true

    constructor(title: TranslationObject, pageId: string, backButtonAction?: () => void, bodyClass?: string, showHeader: boolean = true) {
        this.title = title
        this.pageId = pageId
        this.backButtonAction = backButtonAction
        this.showHeader = showHeader
        this.bodyClass = bodyClass
        uiManager.adController.hideAllAds()
    }

    build(isBackButtonX: boolean = false) {
        // TODO: we should not call this build function. It makes the code more complex
        if(this.hasBeenBuilt) return this.scrollContentToTop()
        this.container = document.getElementById('fullscreen-page-container') as HTMLDivElement
        this.page = createDivIn(this.container, 'fullscreen-page')
        if(this.showHeader) this.header = new UIMFullscreenHeader(this.page, this.title, isBackButtonX)
        this.body = createDivIn(this.page, this.bodyClass ?? 'fullscreen-page-body')

        this.buildView()

        setElementOnClick(this.header.backButton, () => {
            if(this.backButtonAction) {
                Sound.playSound(Sound.SoundType.Click)
                this.backButtonAction()
            }
            if(this.shouldHideOnBackButton) this.hide()
        })

        this.hasBeenBuilt = true
    }

    show() {
        this.page.style.display = 'flex'
        this.scrollContentToTop()
    }

    hide() {
        this.page.style.display = 'none'
    }

    updateHeader(title: TranslationObject) {
        this.title = title
        this.header.title.innerText = clientI18n.t(this.title.key, this.title.options)
    }

    abstract buildView(): void

    removeFromDOM() {
        uiManager.adController.hideBannerAds()
        this.page.remove()
        this.hasBeenBuilt = false
    }

    private scrollContentToTop() {
        const contentSection = this.body.querySelector('.content_singleton_page')
        if(!contentSection) return
        contentSection.scrollTop = 0
    }
}
